/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/
import icon_product from "../../Assets/png_jpg/icon_product.png";

/*FUNCTION*/
import dict from "../../Data/dict.json";
import { block_license_with_handler } from "../../App/actions/filter_license";
/*DATA*/

/*CONST*/

class NO_LICENSE extends Component {
  toggle_payment_table = () => {
    this.props.block_license_with_handler();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props

    //content

    return (
      <>
        <section className="container_light background_white">
          <img src={icon_product} alt="MAPID PRODUCT" width="100" />
          <h1>{dict?.["Feature could not be loaded"]?.[language]}</h1>
          <p>
            {
              dict?.[
              "You do not have a GEO MAPID license yet. Purchase a license to access this feature."
              ]?.[language]
            }
          </p>
          <br />
          <br />
          <br />
          <button
            className="button background_green"
            onClick={this.toggle_payment_table}
          >
            {dict?.["View Plans"]?.[language]}
          </button>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  block_license_with_handler
})(NO_LICENSE);
